<template>
    <form id="onboarding-de" class="wrapper wrapper-tab wrapper-tab-2" role="form" method="post" @submit.prevent="" novalidate>
        <header>
            <span class="new-headline-xlg text-centered">Persönliche Daten</span>
        </header>

        <div class="form-input-wrapper">
            <span class="form-input-title new-text-xl text-bold">Sie sind</span>

            <form-input-type-radio
                :options="[
                    { value: 'm', label: 'männlich' },
                    { value: 'f', label: 'weiblich' },
                    { value: 'x', label: 'divers' }
                ]"
                :errors="errors.sex"
                :value="sex"
                name="sex"
                type="check"
                required
            />

            <span class="form-input-title new-text-xl text-bold">Ihr Geburtsdatum</span>

            <div class="input-wrapper form-input-date-wrapper">
                <div class="form-input-date-inner-wrapper">
                    <form-input-type-select
                        name="day"
                        :options="getDays"
                        :value="getBirthDay"
                        full-border
                        label="Tag"
                        required
                    />

                    <form-input-type-select
                        name="month"
                        :options="getMonths"
                        :value="getBirthMonth"
                        full-border
                        label="Monat"
                        required
                    />

                    <form-input-type-select
                        name="year"
                        :options="getYears"
                        :value="getBirthYear"
                        full-border
                        label="Jahr"
                        required
                    />
                </div>

                <form-input-error v-if="errors.date" :error="errors.date"></form-input-error>
            </div>

            <v-button
                label="Weiter"
                size="lg"
                type="submit"
                @onClick="onClickButton()"
                full-width
            ></v-button>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            uuid: {
                type: String,
                required: true
            },
            data: {
                type: Object,
                required: false
            }
        },

        data() {
            return {
                errors: {
                    date: null
                },
                isDisabled: true,
                sex: this.data && this.data.sex,
                birthday: this.data && this.data.birthday
            }
        },

        mounted() {
            const that = this
            const selectDay = document.getElementById("day")
            const selectMonth = document.getElementById("month")
            const selectYear = document.getElementById("year")

            selectDay.addEventListener('change', function() {
                if($("#day").val() !== "" 
                    && $("#month").val() !== "" 
                    && $("#year").val() !== "") {
                    that.errors.date = null
                }

                that.$forceUpdate();
            })

            selectMonth.addEventListener('change', function() {
                if($("#day").val() !== "" 
                    && $("#month").val() !== "" 
                    && $("#year").val() !== "") {
                    that.errors.date = null
                }

                that.$forceUpdate();
            })

            selectYear.addEventListener('change', function() {
                if($("#day").val() !== "" 
                    && $("#month").val() !== "" 
                    && $("#year").val() !== "") {
                    that.errors.date = null
                }

                that.$forceUpdate();
            })

            setTimeout(() => {
                document.querySelector('.progress-back').addEventListener('click', function(e) {
                    that.saveData();
                }); 
            }, 50);
        },

        computed: {
            getDays() {
                var days = []

                for (let index = 1; index < 32; index++) {
                    days.push({label: index+".", value: index < 10 ? '0'+index : index})
                }

                return days
            },
            getMonths() {
                var months = [
                    {value: '01', label: 'Januar'},
                    {value: '02', label: 'Februar'},
                    {value: '03', label: 'März'},
                    {value: '04', label: 'April'},
                    {value: '05', label: 'Mai'},
                    {value: '06', label: 'Juni'},
                    {value: '07', label: 'Juli'},
                    {value: '08', label: 'August'},
                    {value: '09', label: 'September'},
                    {value: '10', label: 'Oktober'},
                    {value: '11', label: 'November'},
                    {value: '12', label: 'Dezember'}
                ]

                return months
            },
            getYears() {
                var years = []

                for (let index = moment().year() - 18; index > 1900; index--) {
                    years.push({label: index.toString()})
                }

                return years
            },
            getBirthDay() {
                if(this.birthday) {
                    return this.birthday.split("-")[2]
                }

                return null
            },
            getBirthMonth() {
                if(this.birthday) {
                    return this.birthday.split("-")[1]
                }

                return null
            },
            getBirthYear() {
                if(this.birthday) {
                    return this.birthday.split("-")[0]
                }

                return null
            }
        },

        methods: {
            onClickButton() {
                this.validate()

                if(!this.isDisabled) {
                    this.submit()
                } else {
                    Vuemit.fire('Button--sending-failed', true)
                }
            },
            validate() {
                var radioButtonGroup = document.getElementsByName("sex");
                    
                var checkedRadio = Array.from(radioButtonGroup).find(
                    (radio) => radio.checked
                );

                if($("#day").val() == "" || $("#month").val() == "" || $("#year").val() == "") {
                    this.errors.date = "Geburtsdatum muss angegeben werden."
                    this.isDisabled = true
                    this.$forceUpdate();
                }

                if(checkedRadio === undefined) {
                    this.errors.sex = ['Geschlecht muss angegeben werden.']
                    this.isDisabled = true
                    this.$forceUpdate();
                }

                if($("#day").val() !== "" && $("#month").val() !== "" && $("#year").val() !== "") {
                    this.birthday = $("#year").val()+'-'+$("#month").val()+'-'+$("#day").val()

                    if(moment(this.birthday).isValid()) {
                        this.isDisabled = false
                    } else {
                        this.isDisabled = true
                        this.errors.date = "Geburtsdatum muss ein gültiges Datum sein."
                    }
                }

                if(moment(this.birthday).isValid() && checkedRadio !== undefined) {
                    this.errors = {
                        sex: null,
                        date: null
                    }

                    this.sex = checkedRadio.value
                    this.isDisabled = false
                    this.$forceUpdate();
                }
            },
            submit() {
                var data = {
                    uuid: this.uuid,
                    answers: {
                        question_2: {
                            key: 'sex',
                            value: this.sex
                        },
                        question_3: {
                            key: 'birthday',
                            value: this.birthday
                        },
                        last_tab: {
                            key: 'last_tab',
                            value: '2'
                        }
                    }
                }

                axios
                    .post('/rwe-study', data, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((e) => {
                        this.$emit('clicked', data.answers, true)
                    })
                    .catch((e) => {
                        console.log(e.response)
                        Vuemit.fire('Button--sending-failed', true)
                    })
            },
            saveData() {
                var radioButtonGroup = document.getElementsByName("sex");
                    
                var checkedRadio = Array.from(radioButtonGroup).find(
                    (radio) => radio.checked
                );

                this.sex = checkedRadio ? checkedRadio.value : null
                this.birthday = $("#year").val()+'-'+$("#month").val()+'-'+$("#day").val()

                var data = {
                    uuid: this.uuid,
                    answers: {
                        question_2: {
                            key: 'sex',
                            value: this.sex
                        },
                        question_3: {
                            key: 'birthday',
                            value: this.birthday
                        }
                    }
                }

                this.$emit('clicked', data.answers, false)
            }
        }
    }
</script>
